'use client';
import React, { FC } from 'react';
import { Entry } from 'contentful';
import useLocale from '@/hooks/useLocale';
import { FooterSection } from '.';
import { TypeFooterSection } from '@/core/generated-types';
import { shouldHideWithLocaleOverride } from '@/utils/localeOverride';
import { TW_FOOTER_SECTIONS_CLASSES } from '@/core/constants';

interface FooterSectionsProps {
  // TODO: The type of footerSections should be tightened thanks to a migration on the Footer content type to accept TypeFooterSection only instead of accepting any content type.
  footerSections: Entry<Record<string, any>>[];
}

const FooterSections: FC<FooterSectionsProps> = ({ footerSections }) => {
  const locale = useLocale();

  const footerSectionsDisplayed = footerSections.filter((footerSection) => {
    return !shouldHideWithLocaleOverride(footerSection.fields?.localeOverride);
  });

  if (!footerSectionsDisplayed) {
    return null;
  }

  // Defines how the sections are displayed on the grid.
  const gridAreaClasses =
    TW_FOOTER_SECTIONS_CLASSES[locale as string] ||
    TW_FOOTER_SECTIONS_CLASSES['en-US'];

  return (
    <div className="bg-indigo-pastel px-8 pt-5 lg:pb-28 xl:px-[160px]">
      <div className={`${gridAreaClasses} grid grid-rows-auto`}>
        {footerSectionsDisplayed.map((footerSection: TypeFooterSection) => (
          <FooterSection
            key={footerSection.sys.id}
            fields={footerSection.fields}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(FooterSections);
